var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-switch"},_vm._l((_vm.typeList),function(t){return _c('div',{key:t.key,staticClass:"calendar-switch-item",class:{
        'active': t.key === _vm.viewType
      },on:{"click":function($event){return _vm.changeViewType(t)}}},[_vm._v("\n      "+_vm._s(t.label)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }